import * as React from 'react';

import { getTranslation, keys } from '../../../../Resources/Translations';
import { ModalText } from '../../../ReactComponents/Modal/Modal';
import { SessionNotificationModal } from '../../../ReactComponents/Modal/SessionNotificationModal';

export interface RxSessionExpiringModalProps {
    expirationDate: number | null;
    cartPageUrl: string;
    validateBeforeShowing: () => Promise<boolean>;
    minNotificationThresholdSeconds: number;
    maxNotificationThresholdSeconds: number;
}

export const RxSessionExpiringModal = ({
    expirationDate,
    cartPageUrl,
    validateBeforeShowing,
    minNotificationThresholdSeconds,
    maxNotificationThresholdSeconds
}: RxSessionExpiringModalProps) => {
    const minThreshold = minNotificationThresholdSeconds * 1000;
    const maxThreshold = maxNotificationThresholdSeconds * 1000;
    const dismissDateKeyExpiring = 'RxSessionExpiringDismissDate';

    const additionalContent = () => {
        const expiresIn = (expirationDate && Math.ceil((expirationDate - new Date().getTime()) / 60000)) ?? 5;
        const timeUnit = expiresIn > 1 ? getTranslation(keys['modal.rxSession.minutes']) : getTranslation(keys['modal.rxSession.minute']);

        return (
            <div className="RxSessionModal__ContentWrapper">
                <div className="RxSessionModal__ImageWrapper">
                    <img src="/dist/assets/images/register.svg" alt="" className="RxSessionModal__Image" aria-hidden />
                </div>
                <ModalText>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: getTranslation(keys['modal.rxSession.expiringBody']).replace('{time}', `<b>${expiresIn} ${timeUnit}</b>`)
                        }}
                    ></span>
                </ModalText>
            </div>
        );
    };

    return (
        <SessionNotificationModal
            className="RxSessionModal__Expiring"
            onConfirm={() => (window.location.href = cartPageUrl)}
            expirationDate={expirationDate}
            dismissKey={dismissDateKeyExpiring}
            confirmLabel={getTranslation(keys['modal.rxSession.goToCheckout'])}
            cancelLabel={getTranslation(keys['modal.rxSession.close'])}
            heading={getTranslation(keys['modal.rxSession.expiringHeading'])}
            additionalContent={additionalContent()}
            maxNotificationThresholdMs={maxThreshold}
            minNotificationThresholdMs={minThreshold}
            validateBeforeShowing={validateBeforeShowing}
        />
    );
};
